import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=7f56f422&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=ts"
export * from "./SignUp.vue?vue&type=script&lang=ts"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=7f56f422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f56f422",
  null
  
)

export default component.exports